import { CSSObject } from '@chakra-ui/react';

export const FlexBannerWrapper: CSSObject = {
  px: '4',
  py: '2.5',
  m: 'auto',
  h: '12',
  w: 'container.xl',
};

export const FlexItemsWrapper: CSSObject = {
  mr: '0',
  columnGap: '1',
  '& > div:last-of-type': { mr: '0' },
  minH: 'full',
};

export const CountdownTimer = {
  '&': {
    '.countdown-flex': {
      background: 'transparent',
    },
  },
};

export const LinkItem: CSSObject = {
  w: '40',
  h: 'full',
  py: '2px',
  borderRadius: 'md',
  bg: 'rgba(26, 165, 255, 0.15)',
  color: 'white',
  border: '2px solid',
  borderColor: 'whiteAlpha.200',
  textOverflow: 'ellipsis',
  _hover: {
    bg: 'rgba(26, 165, 255, 0.40)',
  },
  '.chakra-badge.state-inprogress': {
    bg: 'beta.500',
    color: 'blackAlpha.800',
    mr: '1',
    mt: '1',
    height: '4',
    borderRadius: 'base',
    maxW: '10',
  },

  '.chakra-badge.state-prior': {
    bg: 'transparent',
    color: 'white',
    mr: '1',
    mt: '1',
    height: '4',
    borderRadius: 'base',
    maxW: '10',
  },

  '.chakra-badge.state-ended': {
    bg: 'alpha.500',
    color: 'white',
    mr: '1',
    mt: '1',
    height: '4',
    borderRadius: 'base',
    maxW: '10',
  },
};

export const RaceNumber: CSSObject = {
  color: 'white',
};
export const FlexDetails: CSSObject = {
  color: 'white',
  display: 'block',
  maxW: '16',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const Icon: CSSObject = {
  color: 'white',
};

export const FlexButtonContainer: CSSObject = {
  bg: 'transparent',
  pos: 'relative',
  p: '0',
  pl: '1',
  gap: '1',
};

export const ButtonChevron: CSSObject = {
  boxSize: '7',
  minW: '7',
  color: 'white',
  p: '0',
  borderRadius: 'md',
  bg: 'rgba(26, 165, 255, 0.15)',
  border: '2px solid',
  borderColor: 'whiteAlpha.200',

  _hover: {
    bg: 'rgba(26, 165, 255, 0.40)',
  },

  '& > svg': { boxSize: '6' },
};
